import { StorageKey, setSessionStorage } from '@utils/StorageUtils';
import { MarketPremiumRetailerClientState } from '../../reducers/market-premium-retailer-client/MarketPremiumRetailerClientReducer';
import { MarketPremiumRetailerClientTypes } from '../Type';

export const updateMarketPremiumRetailerClient = (payload: MarketPremiumRetailerClientState) => {
  return (dispatch: any) => {
    dispatch({
      type: MarketPremiumRetailerClientTypes.MarketPremiumRetailerClientUpdate,
      payload,
    });
    setSessionStorage(StorageKey.MarketPremiumRetailerClient, JSON.stringify(payload));
  };
};
